import Marquee from 'react-fast-marquee';

const PremiumCollection = () => {
  return (
    <section className="bg-gray-100 py-16 px-2 md:px-16 font-playfair">
      <h2 className="text-center text-3xl md:text-4xl font-bold text-gray-800 mb-12">
        Premium Collection
      </h2>

      <div className="relative">
        {/* Marquee Carousel */}
        <Marquee 
          gradient={false} 
          speed={80} // Speed of the scrolling
          pauseOnHover={true} // Pause on hover
        >
          <div className="flex space-x-8">

            {/* Collection 1 */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
              <img
                src="images/banner1.jpg"
                alt="Collection 1"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
                <h3 className="text-xl font-semibold text-white">Luxury Blinds</h3>
                <p className="text-gray-300 text-sm">Transform your space with stylish blinds & shades!.</p>
              </div>
            </div>

            {/* Collection 2 */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
              <img
                src="images/banner2.jpg"
                alt="Collection 2"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
                <h3 className="text-xl font-semibold text-white">Modern Classics</h3>
                <p className="text-gray-300 text-sm">Elegance and privacy, perfectly balanced.</p>
              </div>
            </div>

            {/* Collection 3 */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
              <img
                src="images/banner3.jpg"
                alt="Collection 3"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
                <h3 className="text-xl font-semibold text-white">Exclusive Blinds</h3>
                <p className="text-gray-300 text-sm">Light control made beautiful and effortless.</p>
              </div>
            </div>

            {/* Collection 4 */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
              <img
                src="images/banner4.jpg"
                alt="Collection 4"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
                <h3 className="text-xl font-semibold text-white">Exotic Blends</h3>
                <p className="text-gray-300 text-sm">Blinds that elevate, shades that inspire.</p>
              </div>
            </div>

            {/* Collection 5 */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
              <img
                src="images/banner10.jpg"
                alt="Collection 5"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
                <h3 className="text-xl font-semibold text-white">Elegant shades</h3>
                <p className="text-gray-300 text-sm">Your window, your style – redefine it today!</p>
              </div>
            </div>

            {/* Collection 6 */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
              <img
                src="images/banner6.jpg"
                alt="Collection 6"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
                <h3 className="text-xl font-semibold text-white">Timeless Elegance</h3>
                <p className="text-gray-300 text-sm">Bringing comfort and style to your windows.</p>
              </div>
            </div>

            {/* Add a gap after the last collection */}
            <div className="w-1"></div>
          </div>
        </Marquee>
      </div>
    </section>
  );
};

export default PremiumCollection;


// import Marquee from 'react-fast-marquee';

// const PremiumCollection = () => {
//   return (
//     <section className="bg-gray-100 py-16 px-2 md:px-16 font-playfair">
//       <h2 className="text-center text-3xl md:text-4xl font-bold text-gray-800 mb-12">
//         Premium Collection
//       </h2>

//       <div className="relative">
//         {/* Marquee Carousel */}
//         <Marquee 
//           gradient={false} 
//           speed={80} // Speed of the scrolling
//           pauseOnHover={true} // Pause on hover
//         >
//           <div className="flex space-x-8">

//             {/* Collection 1 */}
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
//               <img
//                 src="images/collection.png"
//                 alt="Collection 1"
//                 className="w-full h-80 object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
//                 <h3 className="text-xl font-semibold text-white">Luxury Fragrance</h3>
//                 <p className="text-gray-300 text-sm">Experience the essence of sophistication.</p>
//               </div>
//             </div>

//             {/* Collection 2 */}
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
//               <img
//                 src="images/collection2.png"
//                 alt="Collection 2"
//                 className="w-full h-80 object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
//                 <h3 className="text-xl font-semibold text-white">Modern Classics</h3>
//                 <p className="text-gray-300 text-sm">Timeless elegance with a modern twist.</p>
//               </div>
//             </div>

//             {/* Collection 3 */}
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
//               <img
//                 src="images/collection3.png"
//                 alt="Collection 3"
//                 className="w-full h-80 object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
//                 <h3 className="text-xl font-semibold text-white">Exclusive Scents</h3>
//                 <p className="text-gray-300 text-sm">Discover rare, exclusive fragrances.</p>
//               </div>
//             </div>

//             {/* Collection 4 */}
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
//               <img
//                 src="images/collection4.png"
//                 alt="Collection 4"
//                 className="w-full h-80 object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
//                 <h3 className="text-xl font-semibold text-white">Exotic Blends</h3>
//                 <p className="text-gray-300 text-sm">An exotic blend of rich fragrances.</p>
//               </div>
//             </div>

//             {/* Collection 5 */}
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
//               <img
//                 src="images/collection5.png"
//                 alt="Collection 5"
//                 className="w-full h-80 object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
//                 <h3 className="text-xl font-semibold text-white">Elegant Scents</h3>
//                 <p className="text-gray-300 text-sm">For a luxurious and refined experience.</p>
//               </div>
//             </div>

//             {/* Collection 6 */}
//             <div className="bg-white shadow-lg rounded-lg overflow-hidden w-72 relative">
//               <img
//                 src="images/collection6.png"
//                 alt="Collection 6"
//                 className="w-full h-80 object-cover"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col justify-end">
//                 <h3 className="text-xl font-semibold text-white">Timeless Elegance</h3>
//                 <p className="text-gray-300 text-sm">Fragrances that define sophistication.</p>
//               </div>
//             </div>

//             {/* Add a gap after the last collection */}
//             <div className="w-1"></div>
//           </div>
//         </Marquee>
//       </div>
//     </section>
//   );
// };

// export default PremiumCollection;
